import { DRIVER_NAME } from "@gogoro/feature-account/services/saga"
import axios from "axios"
import { all, cancel, take } from "redux-saga/effects"
import { createRequestInstance, watchRequests } from "redux-saga-requests"
import { createDriver } from "redux-saga-requests-axios"

import { contractSaga } from "./contract"
import { globalUiSaga } from "./globalUi"
import { orderScooterSaga } from "./orderScooter"
import { scooterSaga } from "./scooter"
import { testRideSaga } from "./testRide"
import { userStateSaga } from "./userState"

const featureAccountAPI = axios.create({
  responseType: "json",
  baseURL: "tw/api/proxy-ad/",
  withCredentials: true,
})

export const HMR_ABORT_SAGAS = "HMR/ABORT_SAGAS"

export default function* rootSaga() {
  yield createRequestInstance({
    driver: {
      [DRIVER_NAME]: createDriver(featureAccountAPI),
    },
  })

  const allSagas = yield all([
    watchRequests({
      abortOn: HMR_ABORT_SAGAS,
    }),
    ...globalUiSaga,
    ...userStateSaga,
    ...scooterSaga,
    ...orderScooterSaga,
    ...contractSaga,
    ...testRideSaga,
  ])

  yield take(HMR_ABORT_SAGAS)
  yield cancel(allSagas)
}
